import React from 'react';

const SVGMail = props => {
  return (
    <div className="svg svg--stroke svg--square-stroke" style={props.style}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" viewBox="0 0 24 24" stroke="#4444ff" width='24'>
        <title>Mail</title>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    </div>
  );
};

export default SVGMail;



// WEBPACK FOOTER //
// ./src/svg/Mail.js